<template>
    <div id="company-setup" class="page-height">
        <MdTitle v-bind:Text="$t('companySetup.companyTitle')" />

        <b-row>
            <b-col md="12" class="mx-auto">
                <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                    <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
                        <div :class="paneClass('contentGeneral')" id="contentGeneral" role="tabpanel">
                            <tab-general v-model="editableItem"
                                :CountryList="CountryList"
                                :StateList="StateList"
                            >
                            </tab-general>
                        </div>
                        <div :class="paneClass('tabPreferences')" id="tabPreferences" role="tabpanel">
                            <tab-preference v-model="editableItem"
                                :defaultuserTemplateList="userTemplateList"
                            >
                            </tab-preference>
                        </div>
                        <div :class="paneClass('tabSubmitter')" id="tabSubmitter" role="tabpanel">
                            <tab-submitter v-model="editableItem.submitterCodesList"
                                :insuranceList="insuranceList"
                                :isReadOnly="isReadOnly"
                            ></tab-submitter>
                        </div>
                    </div>
                </MdTabList>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">

            <b-button-group variant="primary">
                <b-button variant="primary" v-on:click="saveOrEdit">{{$t('Shared.Save')}}</b-button>
                <b-dropdown variant="primary" class="ms-2">
                    <b-dropdown-item :disabled="!editableItem" v-on:click="CallModalResetPassword">{{$t('companySetup.changeSQLPass')}}</b-dropdown-item>
                </b-dropdown>
            </b-button-group>
        </div>

         <CompanySqlPassword
            v-bind:TitleWindow="$t('userHeader.rPassword')"
            @getCodeConditionOK="OnReturnDataModalResetPassword($event)"
            v-bind:ModalId="modalResetPasswordId"
            @getCodeConditionCancel="OnReturnCancelModalResetPassword($event)"
        >
        </CompanySqlPassword>
    </div>
</template>

<script>
import TabGeneral from './tabGeneral.vue';
import TabPreference from './tabPreference.vue';
import TabSubmitter from './tabSubmitter.vue';
import CompanySetupService from '@/services/companies.service.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import CountryService from '@/services/country.service';
import StateService from '@/services/state.service';
import UsersService from '@/services/users.service';
import InsuranceService from '@/services/insurance.service';

export default {
    name: 'CompanySetup',
    mixins: [ShowMessage, DBFunctions],
    components: {
        TabGeneral,
        TabPreference,
        TabSubmitter
    },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: ''
            },
            tablist: [
                { title: this.$t('Shared.General'), link: '#contentGeneral', active: true },
                { title: this.$t('companySetup.SubmitterID'), link: '#tabSubmitter' },
                { title: this.$t('UserPreferences.PrefTitle'), link: '#tabPreferences' }
            ],
            editableItem: {
                submitterCodesList:[]
            },
            activeTab: 1,
            activePaneId: 'contentGeneral',
            pendingChanges: false,
            wasSaved: false,
            CountryList: [],
            StateList: [],
            modalResetPasswordId: 'ModalResetPasswordId',
            isPasswordValid: true,
            isConfirmPasswordValid: true,
            userTemplateList: [],
            insuranceList: [],
            isReadOnly: false,
        };
    },
    computed: {
    },
    methods: {
        tabListChanged(event) {
            this.activeTab = event.activeTabNo;
            this.tablist.forEach((tab, index) => {
                tab.active = index + 1 === event.activeTabNo;
            });
            this.activePaneId = this.tablist[event.activeTabNo - 1].link.replace('#', '');
        },

        paneClass(paneId) {
            return this.activePaneId === paneId ? 'tab-pane fade show active' : 'tab-pane fade';
        },

      
        PrepareData() {
            const submitterComp = this.editableItem.company;
            const submitterData = { ...this.editableItem };

            submitterData.submitterCodesList = submitterData.submitterCodesList.map(item => ({
                company: submitterComp,
                providerId: item.providerid,
                insCode: item.inscode
            }));

            return {
                submitterData
            };
        },

        async saveOrEdit() {
            if (this.validate_required()) {
                if (this.editableItem.company) {
                    await this.update();
                } else {
                    await this.save();
                }
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.InvalidFieldValuesDetected'),
                    'errorAutoHide'
                );
            }
        },

        async save() {
            const { submitterData } = this.PrepareData();
            const dataToSend = this.convertBoolToYN(submitterData);

            await CompanySetupService.add(dataToSend)
                .then(async response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async update() {
            const { submitterData } = this.PrepareData();
            const dataToSend = this.convertBoolToYN(submitterData);

            await CompanySetupService.update(dataToSend)
                .then(async response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            return true;
        },

        initializeEvents() {
            this.$nextTick(() =>
                EventBus.$on(
                    'onChanged',
                    function(e) {
                        this.pendingChanges |= e.Changed;
                    }.bind(this)
                )
            );
        },

        async loadInitialInfoAsync() {
            await CompanySetupService.getAll()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.editableItem = this.convertYNObj(response.data[0]);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        // Método auxiliar para convertir Y/N a booleanos
        convertYNObj(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            if (Array.isArray(obj)) {
                return obj.map(item => this.convertYNObj(item));
            }

            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                if (typeof value === 'string' && value === 'Y') {
                    result[key] = true;
                } else if ( typeof value === 'string' && value === 'N') {
                    result[key] = false;
                } else if (typeof value === 'object' && value !== null) {
                    result[key] = this.convertYNObj(value);
                } else {
                    result[key] = value;
                }
            }
            return result;
        },

        // Convertir booleanos a "Y"/"N"
        convertBoolToYN(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            if (Array.isArray(obj)) {
                return obj.map(item => this.convertBoolToYN(item));
            }

            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                // SOLO transforma si es booleano Y NO es status
                if (typeof value === 'boolean') {
                    // ← Cambiado a else if
                    result[key] = value ? 'Y' : 'N';
                }
                // Si es un objeto (no null), lo procesa recursivamente
                else if (typeof value === 'object' && value !== null) {
                    result[key] = this.convertBoolToYN(value);
                }
                // CUALQUIER OTRO VALOR lo deja igual
                else {
                    result[key] = value;
                }
            }
            return result;
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        async populateSelects() {
            const params = { Active: true};  
            await UsersService.getAll(params)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        response.data.forEach( e  => {
                            this.userTemplateList.push({
                                name: e.userName,
                                code: e.userCode
                            });
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });

            if (this.$store.state.statewasloaded) {
                this.StateList = this.$store.state.StateList;
            } else {
                await StateService.getAll()
                    .then((response) => {
                        if (response.status == '200') {
                            this.StateList = response.data;
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }

            if (this.$store.state.countrywasloaded) {
                this.CountryList = this.getOnlyCountry(this.$store.state.CountryList);
            } else {
                await CountryService.getCountries()
                    .then((response) => {
                        if (response.status == '200') {
                            this.CountryList = this.getOnlyCountry(response.data);
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }
        },

        getOnlyCountry(arr){
            let temp = [];
            arr.forEach(element => {
                temp.push({code:element.name, name:element.name,recId:element.recId});
            });
            return temp;
        },

        IsValidPass(item){
            if(item.Id === "Password"){
                this.isPasswordValid = item.IsValid;
            }

            if(item.Id === "Verify"){
                this.isConfirmPasswordValid = item.IsValid;
            }
        },

        OnReturnDataModalResetPassword(data) {
            this.pendingChanges = false;
            const send = {
                sqlpassword: data.sqlpassword
            };
            this.ResetPassword(send);
        },

        CallModalResetPassword() {
            this.$bvModal.show(this.modalResetPasswordId);
        },

        ResetPassword(data) {
            CompanySetupService.updateSqlpassword(data)
                .then(response => {
                    if (response.status == '200') {
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.MessageResetPasswordOK'), {
                                    title: this.$t('Shared.SavedSuccessfully'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        OnReturnCancelModalResetPassword() {
            console.log('Modal reset password canceled');
        },

        async getUsers() {
            const params = { Active: true};  
            await UsersService.getAll(params)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        response.data.forEach( e  => {
                            this.userTemplateList.push({
                                name: e.userName,
                                code: e.userCode
                            });
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getInsurances() {
            await InsuranceService.getAllInsurances({})
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.insuranceList = response.data.map(value => ({
                            code: value.insurancecode,
                            description: value.company
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async ExecuteAllCalls() {
            await this.getUsers();
            await this.getInsurances();
        },
    },

    created() {
        EventBus.$on(
            'onResetTabList',
            function(item) {
                this.tabListChanged(item);
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        const requestedTabIndex = this.tablist.findIndex(
            tab => tab.link === `#${this.$route.query.tab}`
        );
        this.tabListChanged({ activeTabNo: requestedTabIndex !== -1 ? requestedTabIndex + 1 : 1 });

        const allPromise = Promise.all([await this.ExecuteAllCalls()]);
        await allPromise.then(() => {
            this.populateSelects();
            this.loadInitialInfoAsync();
        }).then(() => this.initializeEvents());
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('onChanged');
        EventBus.$off('onResetTabList');
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('PPDbSetup.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.saveOrEdit();
                    }
                });
        } else {
            next();
        }
    }
};
</script>
